<template>
  <div class="video_area">
    <div class="video_content">
      <div class="nav-header">
        <van-nav-bar :title="infoObj.title" @click-left="leftFn" left-arrow />
        <div
          class="video_wrap_nopay"
          :style="{ 'background-image': `url(${infoObj.coverMaterialUrl})` }"
          v-if="!infoObj.isFree && infoObj.isPay == 0"
        >
          <img
            class="shape-vide"
            src="../../assets/images/parent-course/shape-vide.png"
            alt=""
          />
          <div class="mask"></div>
        </div>
        <div class="video_wrap" v-else>
          <video-player
            @titleClick="titleClick"
            :title="infoObj.title"
            :infoObj="infoObj"
            :options="options"
            :videoInfo="video"
            @onPlayerPlay="handleplay"
            @onPlayerEnded="handlePlayEnd"
            @onPlayerTimeupdate="handlePlayerTimeupdate"
            @onPlayerLoadeddata="loadDate"
            @onPlayerPause="pauseFn"
            ref="videoPlayer"
          ></video-player>
        </div>
        <section class="des-container">
          <div class="container-box">
            <!-- 非免费且支付了 -->
            <!-- <div class="box" v-if="!infoObj.isFree && infoObj.isPay">
              <div class="container-title">
                {{ infoObj.title }}
              </div>
              <div @click.stop.prevent="collectClick" class="heart-warp">
                <div class="collect_blank" v-if="yesAttentionFlag"></div>
                <div
                  class="collect_blank collect_have"
                  v-if="noAttentionFlag"
                ></div>
                <span class="collect">收藏</span>
              </div>
            </div> -->
            <!-- 未支付 -->
            <template>
              <Price
                v-if="!infoObj.isFree && infoObj.isPay < 1"
                :number="infoObj.price"
              ></Price>
              <div @click.stop.prevent="collectClick" class="heart-warp">
                <div class="collect_blank" v-if="yesAttentionFlag"></div>
                <div
                  class="collect_blank collect_have"
                  v-if="noAttentionFlag"
                ></div>
                <div class="collect">收藏</div>
              </div>
              <div class="box">
                <div style="width: 80%">
                  <van-tag
                    v-if="!infoObj.isFree && infoObj.isPay < 1"
                    size="medium"
                    color="#1A0801"
                    text-color="#FFE499"
                    >付费</van-tag
                  >
                  <span class="des-text">
                    {{ infoObj.title }}
                  </span>
                </div>
              </div>
            </template>
          </div>
          <div
            class="tag_area"
            v-if="infoObj.labels && infoObj.labels.length > 0"
          >
            <span
              class="tag_wrap"
              v-for="(item, index) in infoObj.labels"
              :key="index"
              >{{ item.label }}</span
            >
          </div>
          <!-- <div class="tag_area" v-if="infoObjTag">
            <span
              class="tag_wrap"
              v-for="(item, index) in infoObjTag"
              :key="index"
              >{{ item }}</span
            >
          </div> -->

          <div class="author-warp">
            <div class="author-left">
              <div class="gray-circle"></div>
              <span class="author-name">{{ infoObj.author }}</span>
            </div>
            <span class="public-date">{{ getTime(infoObj.createTime) }}</span>
          </div>
        </section>
      </div>

      <main class="mian-warp">
        <section v-if="infoObj.description">
          <div class="deatil-warp">
            <h2 class="deatil-title">视频介绍：</h2>
            <div class="deatil-des" v-html="infoObj.description"></div>
          </div>
        </section>

        <section class="more-videos" v-if="videoInfos.length > 0">
          <p>更多相关视频：</p>
          <div class="container_video">
            <ul class="video_ul">
              <li
                class="video_li"
                v-for="(item, index) in videoInfos"
                :key="index"
                @click="getModuleMoreVideo(item)"
              >
                <div class="the_video" v-if="item.coverMaterialUrl">
                  <div class="img_bg"></div>
                  <div class="price-tip" v-if="!item.isFree && !item.isPay">
                    <Price
                      color="#FFFFFF"
                      baseFountSize="16px"
                      class="price-tip-text"
                      :number="item.price"
                    ></Price>
                  </div>
                  <img :src="item.coverMaterialUrl | addHost" alt="photo" />
                </div>
                <div class="the_video_1" v-else>
                  <div class="img_bg"></div>
                </div>
                <p class="the_desc">
                  <van-tag
                    v-if="!item.isFree && !item.isPay"
                    color="#1A0801"
                    text-color="#FFE499"
                    >付费</van-tag
                  >
                  {{ item.title }}
                </p>
              </li>
            </ul>
          </div>
        </section>

        <section class="purchase-notes" v-if="!infoObj.isFree">
          <p class="purchase-notes-title">购买须知：</p>
          <p class="purchase-notes-des">
            知识店铺课程为付费课程的，按照课程计划定期更新，
            每节课可在开课时学习，也可反复回听，该课程听课权益跟随支付购买微信账号ID，
            不支持更换，线上课程为虚拟付费内容，一经订阅不可退费，
            转让，请您于购买时谨慎考虑，如您需要开票，请联系店铺申请开具发票。
            请联系店铺申请开具发票。该作品版权归原作者所有，禁止任何形式的商业使用（含翻录、传播等侵权行为），
            违反者将依法承担法律责任。
          </p>
        </section>
      </main>

      <div class="footer-warp" v-if="!infoObj.isFree && infoObj.isPay < 1">
        <!-- <div @click.stop.prevent="collectClick" class="heart-warp">
          <div class="collect_blank" v-if="yesAttentionFlag"></div>
          <div class="collect_blank collect_have" v-if="noAttentionFlag"></div>
          收藏
        </div> -->
        <van-button round @click="buyAtOnce">{{ btnText }}</van-button>
      </div>
    </div>
    <!-- 播放完毕获取金币的弹框 -->
    <modal
      ref="modalPop"
      :btnType="endBtnType"
      sureText="下一个"
      cancelText="关闭"
      @cancel="cancelFn"
      @submit="nextFn"
    >
      <template v-slot:top>
        <p>很棒哦！继续努力，你会做的更好！</p>
      </template>
      <template v-slot:body>
        <div class="score_area">
          <div class="money">
            <img
              src="../../assets/images/parent-course/money.png"
              alt="money"
            />
            <span>X4</span>
          </div>
          <p>恭喜获得四个积分</p>
        </div>
      </template>
    </modal>
    <!--得过积分再看视频时推出 -->
    <modal
      ref="finishPop"
      btnType="2"
      sureText="确认"
      cancelText="取消"
      @cancel="finishCancelFn"
      @submit="finistSure"
    >
      <template v-slot:body>
        <p>您确定退出吗？</p>
      </template>
    </modal>
    <!--反复观看完或者拖拽播放完 -->
    <modal
      ref="endPop"
      :btnType="endBtnType"
      :sureText="endSureText"
      cancelText="知道了"
      :ifHasVideo="ifHasVideo"
      @cancel="endCancelFn"
      @submit="endSure"
    >
      <template v-slot:body>
        <p>播放完成</p>
      </template>
    </modal>
  </div>
</template>

<script>
import VideoPlayer from "../../components/video/index.vue";
import {
  _userAttention,
  _julyAttention,
  _delAttention,
  _getUserConcerned,
  _getCourseList,
  _moreCorrelation,
  _addIntegral,
  _checkUserWatch,
  _nextVideo,
  _detail,
} from "../../api/parent-course";
import { Toast } from "vant";
import { decryptBy } from "@/assets/js/encryption";
import Modal from "../../components/common/modal.vue";
import { _recordTimes } from "../../api/growth";
import { time } from "echarts";
import BScroll from "better-scroll";
import { verticalScreen } from "../../assets/js/vertical-screen";
import Price from "../../components/price/price.vue";
export default {
  inject: ["reload"],
  name: "v-video",
  components: { VideoPlayer, Modal, Price },
  pros: {},
  data() {
    return {
      objTime: {},
      videoTimeAll: 0, //视频的时间总长度
      endCounet: 0, //播放end的总次数
      playedOk: false, //播放完成
      endBtnType: "2", //播放完毕按钮的状态，如果没有下一个视频，就显示一个按钮，文案为 知道了
      endSureText: "下一个",
      // 记录时间
      recordParams: {
        contentId: "",
        day: "",
        seconds: "",
        userId: "",
      },
      alreadyPlayed: false, //当前视频是否播放完毕
      userId: "", //用户id
      tabNum: "", //首页对应的tab页
      showMore: true, //是否展示更多视频（有无更多视频数据）
      finishText: "没有数据了哦！",
      loading: false,
      loadMoreFlag: true, //是否加载了一次
      showemptyData: false,
      finished: false, //加载状态
      moreVideoList: [],
      noAttentionFlag: false, //用户否收藏的标志
      yesAttentionFlag: false, //用户否收藏的标志
      video: {}, // 单种视频详情
      flagCollect: false,
      fullScreen: false,
      metInfo: 2.8,
      playTime: 0,
      titleText: "默认标题",
      showModal: false,
      infoObj: {}, //页面视频相关信息
      attentionParams: {
        contentId: "",
        cuserId: "",
      },
      videoInfos: [], //更多视频推荐的数据，再上一步secondstep中请求的数据或者是本页中更多相关视频推荐的数据
      // 首页-收藏-更多视频（多一个contentId参数）
      concernParams: {
        asc: false,
        currentPage: 1,
        // orderByField: "createTime",
        pageSize: 50, //每页多少条
        tag: "家长",
        queryData: {
          contentId: "",
          contentType: "VIDEO",
        },
      },
      // 推荐和精选下的更多相关视频
      contentParams: {
        asc: false,
        currentPage: 1,
        // orderByField: "createTime",
        pageSize: 50, //每页多少条
        queryData: {
          contentId: "",
          handpick: false,
          tag: "家长",
          top: false,
          recommend: true,
          contentTypeList: ["VIDEO"],
        },
      },
      // 各个级别下的视频更多视频的参数
      moreParams: {
        asc: false,
        currentPage: 1,
        // orderByField: "createTime",
        pageSize: 50, //每页多少条
        queryData: {
          columnId: "",
          contentId: "",
          contentType: "VIDEO",
          putaway: true,
        },
      },
      // 积分的参数
      integParams: {
        businessId: "", //文章视频id
        name: "", //文章视频名称
        type: "", //2文章 3视频
      },
      // 查询用户是否观看过此视频
      watchParams: {
        businessId: "", //视频或者文章的id
        // userId:'',//用户id
      },
      alreadSend: false, //是否已经发送获取积分
      drawFlag: false, //是否被拖拽
      videoPlayedFlag: false, //视频是否被播放过，是的话就不能弹金币的弹框
      ifHasVideo: false, //是否有下一条视频
      columnId: "", //栏目id
      isMark: "", //是否是收藏栏目
      isPick: "", //是否是精选栏目
      isRecommend: "", //是否是推荐栏目
      nowContentId: "", //当前视频id
      from: "",
      courseId: "",
      recommendationList: [], //推荐数据
    };
  },
  watch: {},
  computed: {
    options() {
      return {
        sources: [
          {
            type: "video/mp4",
            // src:'http://172.16.70.46:8300/video/sport/man/01.m4v',
            // src:'http://172.16.12.229:9100/psy-bucket/1427874319594680321.mp4'
            // src: 'http://172.16.12.229:9100/' + JSON.parse(this.infoObj.materialIdList)[0].url
            // src: 'http://172.16.12.104:8999/' + JSON.parse(this.infoObj.materialIdList)[0].url

            src: JSON.parse(this.infoObj.materialIdList)[0].url,
            // src: 'http://' + location.host + '/' + JSON.parse(this.infoObj.materialIdList)[0].url
          },
        ],
        // poster: 'https://avatars.githubusercontent.com/u/499550?v=4',
        // poster: 'http://172.16.12.229:9100/' + this.infoObj.coverMaterialUrl,
      };
    },
    infoObjTag() {
      return (
        this.infoObj &&
        this.infoObj.tags &&
        this.infoObj.tags.split(",").slice(0, 3)
      );
    },
    btnText() {
      if (this.infoObj.isFree) {
        return "免费视频";
      } else {
        if (this.infoObj.isPay) {
          return "已购买";
        } else {
          return "立即购买￥" + this.infoObj.price;
        }
      }
    },
  },
  methods: {
    // 暂停事件
    pauseFn(player) {},
    getTime(time) {
      if (time) {
        var timearr = time.split(" ");
        var timestr = timearr[0];
        return timestr;
      }
    },
    leftFn() {
      if (this.$router.app._route.query.sourceType) {
        this.$router.push("/");
      } else {
        if (!this.alreadyPlayed) {
          //没有播放完
          this.$refs.finishPop.openDialog();
        } else {
          this.$router.back();
        }
      }
    },

    handlePlayerLoad() {},
    collectClick() {
      this.attentionParams.contentId = this.infoObj.id;
      // this.noAttentionFlag = !this.noAttentionFlag
      // 没有收藏，点击发送收藏
      if (this.noAttentionFlag) {
        // send收藏
        this.userAttention(this.attentionParams);
      } else if (this.yesAttentionFlag) {
        // 已经收藏，点击取消收藏
        this.delAttention({ contentId: this.infoObj.id });
      }
    },
    titleClick(e, player) {
      // this.$router.back();
      //退出全屏
      this.$refs.videoPlayer.setFullScreen(false);
    },
    handleplay(e) {
      //   this.startTime = dayjs().format('HH:mm:ss');
      // 默认竖屏
      // this.$refs.videoPlayer.setFullScreen(false);
    },
    // 关闭积分弹框的事件
    cancelFn() {
      this.$refs.modalPop.closeDialog();
    },
    //积分确认的弹框事件
    nextFn() {
      // 下一个视频
      if (this.endBtnType == "1") {
        this.$refs.modalPop.closeDialog();
        return;
      }
      this.from = 2;
      this.nextVideo();
    },

    // 播放完毕
    async handlePlayEnd(endFlag) {
      try {
        if (!endFlag) {
          this.playedOk = true; //播放完程
          this.endCounet++; // 播放次数统计
          this.objTime.time = this.videoTimeAll;
          Object.freeze(this.objTime);
        }
        // 播放完毕，定义一个状态
        this.alreadyPlayed = true;
        // fullScreed 为false 播放完毕后
        // 1.没有拖拽&&首次观看，发请求获取积分
        if (!this.drawFlag && this.videoPlayedFlag) {
          //没有拖拽，请求发送 videoPlayedFlag为true，表示没有播放过
          // await this.addIntegral(this.integParams)
        }
        // 拖拽视频，不给积分，不发请求
        // 拖拽视频，不弹金币的框
        //
        // 金币弹框出现的条件： 首次观看&&没有拖拽
        if (!this.drawFlag && this.videoPlayedFlag) {
          // this.$refs.modalPop.openDialog()
        } else {
          // 播放结束的弹框，对应快进播放完或者拖拽播放完

          this.$refs.endPop.openDialog();
        }
        // 播放完毕后，中途的所有退出时刻的弹框都必须隐藏
        this.$refs.finishPop.closeDialog();
        this.$refs.scorePop.closeDialog();
      } catch (error) {
        // 此处有可能会报freeZe问题，不改
      }
    },
    // 得过积分再推出的弹框
    finistSure() {
      this.$router.back();
    },
    finishCancelFn() {
      this.$refs.finishPop.closeDialog();
    },
    // 反复观看过播放完成或者拖拽后播放完成
    endCancelFn() {
      this.$refs.endPop.closeDialog();
    },
    endSure() {
      // 播放完毕，没有下一个视频，就显示一个按钮，点击关闭弹框
      if (this.endBtnType == "1") {
        this.$refs.endPop.closeDialog();
        return;
      }
      this.from = 2;
      this.nextVideo();
    },
    // 首次观看视频的时候中途推出
    //取消
    scoreCancelFn() {
      this.$refs.scorePop.closeDialog();
    },
    // 确认
    scoreSure() {
      // 退出当前页面
      this.$router.back();
    },
    handlePlayerTimeupdate(player) {
      // 获取播放时长
      this.playTime = player.currentTime();
      this.recordParams.seconds = Math.round(this.playTime);
      // 当播放完毕，有了统计结束的次数，才能获得到整体的视频时间长度
      this.videoTimeAll = Math.round(this.playTime);
    },
    loadDate() {},
    // 拖拽视频
    drawFn() {
      this.$bus.$on("drawEv", (val) => {
        this.drawFlag = val;
      });
    },
    // 点击更多视频
    // toNewVideo(item) {
    //   this.$storage.setStore('videoInfo',item)
    //   // 刷新页面重新加载当前点击的视频
    //   this.reload()
    // },
    // 更多视频，相关推荐，点击更多视频进入页面的时候，下方推荐的视频重新请求数据
    //需要调用三个不同的接口，推荐模块更多相关视频接口 精选/推荐更多相关视频接口 其他是一个接口
    // tab默认是推荐页，也就是1 为空的时候，也是1
    async getModuleMoreVideo(item) {
      localStorage.setItem("paymentDate", JSON.stringify(item));
      if (!item.putaway) {
        Toast("商品已下架！");
        return;
      }
      if (item.isCourse) {
        if (!item.isFree && !item.isPay) {
          this.$router.push(`/coursePlateNopay/${item.courseId}`);
          return;
        } else {
          this.$storage.setStore("courseInfo", item);
          this.$router.push(`/coursePlate/${item.courseId}`);
          return;
        }
      } else {
        let _this = this;
        _this.contentParams.queryData.courseId = item.courseId;
        const data = await _this.detail(item.id, item.courseId);
        _this.infoObj = data;
        localStorage.setItem("videoInfo", JSON.stringify(data));
        localStorage.setItem("paymentDate", JSON.stringify(data));
        // 点击当前的视频，将item赋值，然后刷新页面播放选中的视频
        let temTab = JSON.parse(localStorage.getItem("tabPage"));
        let num = sessionStorage.getItem("tabTitlelen");
        if (temTab === num - 3) {
          //收藏，走收藏的推荐接口
          // 如果是收藏，那么进入收藏视频中的时候，走concerned接口，区别在于多一个contentId字段
          _this.concernParams.queryData.contentId = item.id;
          await _this.getUserConcerned(_this.concernParams);
          _this.$router.replace("/loadingPage");
          // this.toWhere(item)
        } else if (!temTab || temTab === 0) {
          //推荐 走相同的putaway接口，多一个字段contentId
          _this.contentParams.queryData.contentId = item.id;
          _this.contentParams.queryData.recommend = true;
          _this.contentParams.queryData.handpick = false;
          await _this.getCourseList(_this.contentParams);
          _this.$router.replace("/loadingPage");
          // this.toWhere(item)
        } else if (temTab === num - 1) {
          //精选 走相同的putaway接口，多一个字段contentId
          _this.contentParams.queryData.contentId = item.id;
          _this.contentParams.queryData.recommend = false;
          _this.contentParams.queryData.handpick = true;
          await _this.getCourseList(_this.contentParams);
          _this.$router.replace("/loadingPage");
          // this.toWhere(item)
        } else {
          //除了前三个收藏 推荐 精选，其他的都是一级一级的走下来，走到栏目下面，更多相关视频走
          _this.moreParams.queryData.contentId = item.id;
          if (localStorage.getItem("labelIds")) {
            _this.moreParams.queryData.columnId =
              localStorage.getItem("labelIds");
          } else {
            _this.moreParams.queryData.columnId = item.courseId;
          }
          await _this.moreCorrelation(_this.moreParams);
          _this.$router.replace("/loadingPage");
          // this.toWhere(item)
          // 模拟一个假的页面，并且迅速跳回当前播放页面
        }
      }
      // let _this = this;
      // _this.contentParams.queryData.courseId = item.courseId;
      // // 点击当前的视频，将item赋值，然后刷新页面播放选中的视频
      // let temTab = JSON.parse(localStorage.getItem("tabPage"));
      // if (temTab === 1) {
      //   //收藏，走收藏的推荐接口
      //   // 如果是收藏，那么进入收藏视频中的时候，走concerned接口，区别在于多一个contentId字段
      //   _this.concernParams.queryData.contentId = item.id;
      //   await _this.getUserConcerned(_this.concernParams);
      //   this.$router.replace("/loadingPage");
      //   // this.toWhere(item)
      // } else if (!temTab || temTab === 0) {
      //   //推荐 走相同的putaway接口，多一个字段contentId
      //   _this.contentParams.queryData.contentId = item.id;
      //   _this.contentParams.queryData.recommend = true;
      //   _this.contentParams.queryData.handpick = false;
      //   await _this.getCourseList(this.contentParams);
      //   this.$router.replace("/loadingPage");
      //   // this.toWhere(item)
      // } else if (temTab === 3) {
      //   //精选 走相同的putaway接口，多一个字段contentId
      //   _this.contentParams.queryData.contentId = item.id;
      //   _this.contentParams.queryData.recommend = false;
      //   _this.contentParams.queryData.handpick = true;
      //   await _this.getCourseList(this.contentParams);
      //   this.$router.replace("/loadingPage");
      //   // this.toWhere(item)
      // } else {
      //   //除了前三个收藏 推荐 精选，其他的都是一级一级的走下来，走到栏目下面，更多相关视频走
      //   _this.moreParams.queryData.contentId = item.id;
      //   if (localStorage.getItem("labelIds")) {
      //     _this.contentParams.queryData.columnId =
      //       localStorage.getItem("labelIds");
      //   } else {
      //     _this.contentParams.queryData.columnId = item.courseId;
      //   }
      //   await _this.moreCorrelation(this.moreParams);
      //   this.$router.replace("/loadingPage");
      //   // this.toWhere(item)
      //   // 模拟一个假的页面，并且迅速跳回当前播放页面
      // }
      // 此处顺序是为了保证获取数据后才赋值给当前播放的视频，必要闪烁
      // _this.infoObj = item;
      // 将当前点击的item保存到local中，刷新页面后就能读取到当前视频(用了computed，暂时不用刷新页面)
      // console.log(item,'0000000000000000')
      // localStorage.setItem("videoInfo", JSON.stringify(item));
      // let temTab = JSON.parse(localStorage.getItem("tabPage"));
    },
    // 获取user收藏的内容
    async getUserConcerned(concernParams) {
      try {
        let res = await _getUserConcerned(concernParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          this.videoInfos = data.records;
          localStorage.setItem("videoInfos", JSON.stringify(this.videoInfos));
        } else {
          this.videoInfos = [];
          localStorage.removeItem("videoInfos");
          Toast(message);
        }
      } catch (error) {
        this.loading = false;
      }
    },
    // 获取推荐和精选的视频
    async getCourseList(contentParams) {
      try {
        let res = await _getCourseList(contentParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          this.videoInfos = data.records;
          localStorage.setItem("videoInfos", JSON.stringify(this.videoInfos));
        } else {
          this.videoInfos = [];
          localStorage.removeItem("videoInfos");
          Toast(message);
        }
      } catch (error) {}
    },
    //各个级别走下去的时候获取更多相关视频
    async moreCorrelation(moreParams) {
      // 如果是
      try {
        let res = await _moreCorrelation(moreParams);
        let { code, message, data } = res;
        if (res && code === 200) {
          if (data && data.records.length > 0) {
            this.videoInfos = data.records;
            localStorage.setItem("videoInfos", JSON.stringify(this.videoInfos));
            // this.showMore = true
          } else {
            this.videoInfos = [];
            localStorage.removeItem("videoInfos");
          }
        } else {
          this.videoInfos = [];
          localStorage.removeItem("videoInfos");
          Toast(message);
        }
      } catch (error) {}
    },
    // 用户收藏
    async userAttention(attentionParams) {
      try {
        let res = await _userAttention(attentionParams);
        let { code, message, data } = res;
        if (res && code === 200) {
          if (data) {
            Toast("收藏成功");
          } else {
            Toast("收藏失败，请稍后尝试");
          }
        } else {
          Toast("收藏失败，请检查网络");
        }
        // 查询是否收藏成功
        this.julyAttention({ contentId: this.infoObj.id });
      } catch (error) {}
    },
    // 用户取消收藏
    async delAttention(delParams) {
      try {
        let res = await _delAttention(delParams);
        let { code, data, message } = res;
        if (res && code === 200) {
          if (data) {
            this.noAttentionFlag = true;
            this.yesAttentionFlag = false;
            Toast("取消收藏");
          } else {
            this.noAttentionFlag = false;
            this.yesAttentionFlag = true;
          }
        } else {
          Toast(message);
          this.noAttentionFlag = false;
          this.yesAttentionFlag = true;
        }
        // 查询是否取消收藏成功
        this.julyAttention({ contentId: this.infoObj.id });
      } catch (error) {
        console.error(error);
      }
    },
    // 查询用户是否收藏
    async julyAttention(contentId) {
      try {
        let res = await _julyAttention(contentId);
        let { code, data, message } = res;
        if (res && code === 200) {
          if (data) {
            this.yesAttentionFlag = true;
            this.noAttentionFlag = false;
          } else {
            this.noAttentionFlag = true;
            this.yesAttentionFlag = false;
          }
        } else {
          Toast(message);
          this.noAttentionFlag = true;
          this.yesAttentionFlag = false;
        }
      } catch (error) {}
    },
    //积分获取的接口
    async addIntegral(integParams) {
      try {
        let res = await _addIntegral(integParams);
        let { code, message, data } = res;
        if (res && code === 200) {
          this.alreadSend = true; //已经发送
        } else {
          this.alreadSend = false; //没有发送或者发送失败
          Toast(message);
        }
      } catch (error) {}
    },
    // 查询用户是否观看过此视频
    async checkUserWatch(watchParams) {
      try {
        let res = await _checkUserWatch(watchParams);
        let { code, message, data } = res;
        if (res && code === 200) {
          if (data) return (this.videoPlayedFlag = true); //data返回为true，没有播放过
          this.videoPlayedFlag = false;
        } else {
          this.videoPlayedFlag = false;
          Toast(message);
        }
      } catch (error) {}
    },
    // 记录次数
    async recordTimes(recordParams) {
      try {
        let res = await _recordTimes(recordParams);
      } catch (error) {}
    },
    //下一条视频
    nextVideo() {
      let data = this.recommendationList[0];
      localStorage.setItem("videoInfo", JSON.stringify(data));
      this.getModuleMoreVideo(data);

      // this.nowContentId = data.id;
      // this.$router.replace("/loadingPage");
      // console.log(this.nowContentId, "5555555555555");
      // _nextVideo({
      //   columnId: this.columnId,
      //   nowContentId: this.nowContentId,
      //   isMark: this.isMark,
      //   isPick: this.isPick,
      //   isRecommend: this.isRecommend,
      // }).then((res) => {
      //   if (res.code == 200) {
      //     if (res.data) {
      //       this.ifHasVideo = true;
      //       this.endBtnType = "2";
      //       this.endSureText = "下一个";
      //       if (this.from == 2) {
      //         localStorage.setItem("videoInfo", JSON.stringify(res.data));
      //         this.nowContentId = res.data.id;
      //         this.$router.replace("/loadingPage");
      //       }
      //     } else {
      //       this.endBtnType = "1";
      //       this.endSureText = "知道了";
      //       this.ifHasVideo = false;
      //     }
      //   } else {
      //     this.endBtnType = "1";
      //     this.endSureText = "知道了";
      //     this.ifHasVideo = false;
      //   }
      // });
    },
    async detail(id, courseId) {
      if (courseId == "") {
        var res = await _detail({ id });
      } else {
        var res = await _detail({ id, courseId });
      }
      if (res.code == 200) {
        localStorage.removeItem("isCourse");
        return res.data;
      }
    },

    buyAtOnce() {
      if (
        (!this.infoObj.isFree && !this.infoObj.isPay) ||
        (this.infoObj.courseType && this.infoObj.courseType == 2)
      ) {
        localStorage.setItem("adress", "");
        sessionStorage.setItem("orderDetails", JSON.stringify(this.infoObj));
        if (this.infoObj.courseType && this.infoObj.courseType == 2) {
          //true 线下课程 false 线上课程
          this.$router.push("/outlineOrderConfirm");
        } else {
          this.$router.push("/orderConfirm");
        }
      }
    },
  },
  filters: {
    addHost: function (val) {
      let host = location.host;
      // return 'http://' + host + '/' + val
      // return 'http://172.16.12.104:8999/' + val
      return val;
    },
  },
  beforeCreate() {},
  async created() {
    try {
      let _this = this;
      // 获取用户的id
      // let user = JSON.parse(decryptBy(localStorage.getItem("userInfo")));
      // this.userId = user.userId
      _this.drawFn();
      // videoInfo为当前的视频信息对象
      //videoInfos为更多推荐视频的视频信息数组
      // 获取video对用的信息
      _this.infoObj = JSON.parse(localStorage.getItem("videoInfo"));
      if (_this.$route.query.courseId) {
        _this.courseId = _this.$route.query.courseId;
      } else {
        _this.courseId = "";
      }
      if (_this.$route.query.videoId) {
        const data = await _this.detail(
          _this.$route.query.videoId,
          _this.courseId
        );
        _this.infoObj = data;
        _this.recordParams.contentId = data.id; //记录时间的id
      }

      // _this.infoObj.isFree = 0;
      // _this.infoObj.isPay = 1;

      // 吧家长信息切换为用户信息了

      let infoDeatil = JSON.parse(decryptBy(localStorage.getItem("userInfo")));
      _this.userId = infoDeatil.userId;
      _this.recordParams.userId = infoDeatil.userId; //家长id

      let yearNow = new Date().getFullYear();
      let monthNow = new Date().getMonth() + 1;
      let dayNow = new Date().getDate();
      if (+monthNow < 10) monthNow = "0" + monthNow;
      if (+dayNow < 10) dayNow = "0" + dayNow;
      let allDaty = yearNow + "-" + monthNow + "-" + dayNow;
      _this.recordParams.day = allDaty;
      _this.integParams.businessId = _this.infoObj.id;
      _this.integParams.name = _this.infoObj.title;
      _this.integParams.type = 3; //视频
      _this.julyAttention({
        contentId: _this.infoObj.id,
      });
      // 获取到首页中的点击tab页，0是收藏，1是推荐 2是精选，其他是>3
      _this.tabNum = _this.$storage.getStore("tabPage");
      let colu = localStorage.getItem("colu");
      if (colu) {
        if (colu == "收藏") {
          _this.columnId = "";
          _this.isMark = 1;
          _this.isPick = 0;
          _this.isRecommend = 0;
        } else if (colu == "精选") {
          _this.columnId = "";
          _this.isMark = 0;
          _this.isPick = 1;
          _this.isRecommend = 0;
        } else if (colu == "推荐") {
          _this.columnId = "";
          _this.isMark = 0;
          _this.isPick = 0;
          _this.isRecommend = 1;
        }
      } else {
        _this.columnId = _this.$storage.getStore("firstOtherPlateInfo")
          ? _this.$storage.getStore("firstOtherPlateInfo").id
          : _this.$storage.getStore("columnId");
        _this.isMark = 0;
        _this.isPick = 0;
        _this.isRecommend = 0;
      }
      _this.nowContentId = _this.infoObj.id;
      //_this.nextVideo();
    } catch (error) {
      console.error(error);
    }
  },
  beforeMount() {},
  mounted() {
    verticalScreen();
    // this.$refs.finishPop.openDialog()
    let _this = this;
    _this.$refs.videoPlayer && _this.$refs.videoPlayer.autoPlayVideo();
    // 通过一级一级栏目下，进入到视频中下方获取更多相关视频
    // this.moreCorrelation(this.moreParams)
    // 获取更多视频，上一步保存的数据
    let temvideoInfos = localStorage.getItem("videoInfos");
    _this.videoInfos = JSON.parse(temvideoInfos);
    // console.log(_this.videoInfos.length,'6666666666')
    if (_this.videoInfos && _this.videoInfos.length > 0) {
      for (var i in _this.videoInfos) {
        if (
          (_this.videoInfos[i].type == "VIDEO" && _this.videoInfos[i].isFree) ||
          (_this.videoInfos[i].type == "VIDEO" &&
            _this.videoInfos[i].isPay != 0)
        ) {
          _this.recommendationList.push(_this.videoInfos[i]);
        }
      }
      if (_this.recommendationList && _this.recommendationList.length > 0) {
        this.endBtnType = "2";
        this.endSureText = "下一个";
      } else {
        this.endBtnType = "1";
        this.endSureText = "知道了";
      }
    } else {
      this.endBtnType = "1";
      this.endSureText = "知道了";
    }

    let columnId = _this.$storage.getStore("firstOtherPlateInfo")
      ? _this.$storage.getStore("firstOtherPlateInfo").id
      : "";
    _this.moreParams.queryData.columnId = columnId;
    // 查询用户是否观看过此视频
    _this.watchParams.businessId = _this.infoObj.id;
    // _this.watchParams.userId = _this.userId
    // _this.checkUserWatch(this.watchParams)
    _this.from = _this.$route.query.from;
  },
  activated() {},
  deactivated() {},
  beforeDestroy() {
    let timeInfo = 0;
    if (this.playedOk) {
      // 播放完成了，此时videoTimeAll为总时长
      if (this.recordParams.seconds == this.objTime.time)
        this.recordParams.seconds = 0; // 当我播放完一个视频之后，如果没有再次播放，那么这个时间设置为0
      timeInfo = this.endCounet * this.objTime.time + this.recordParams.seconds;
    } else {
      timeInfo = this.recordParams.seconds;
    }
    this.recordParams.seconds = timeInfo;
    if (timeInfo) this.recordTimes(this.recordParams);
  },
  destroyed() {},
};
</script>

<style lang="scss">
$heart_have: "../../assets/images/parent-course/heart-bg.png";
$heart_blank: "../../assets/images/parent-course/heart_blank.png";
$video_bg: "../../assets/images/parent-course/video.png";
$video_Blank: "../../assets/images/parent-course/video-blank.png";
$close: "../../assets/images/parent-course/close.png";
.video_area {
  font-weight: 500;
  overflow-y: hidden;
  height: 100%;
  .video_content {
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    height: 100%;
    background-color: #f5f7fa;
  }
  .nav-header {
    width: 100%;
    background-color: #fff;
    .van-nav-bar__title {
      font-size: 18px;
      font-weight: 500;
    }
    .des-container {
      padding: 0px 20px 12px 20px;
      background-color: #fff;
      .container-box {
        overflow: hidden;
        margin-top: 5px;
        .box {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          width: 80%;
          float: left;
          margin-top: 5px;
        }
        .collect {
          font-size: 14px;
          font-weight: 400;
          color: #2e4344;
        }
        .container-title {
          width: 82%;
          font-size: 16px;
          color: #3c4130;
          word-break: break-all;
        }
        .heart-warp {
          padding: 4px, 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          float: right;
          .collect_blank {
            width: 22px;
            height: 22px;
            background: url($heart_blank) no-repeat;
            background-size: contain;
          }
          .collect_have {
            background: url($heart_have) no-repeat;
            background-size: contain;
          }
        }
        .nopay-top {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-bottom: 4px;
          align-items: center;
        }
        .title-box {
        }
      }
      .des-container-text {
        width: 100%;
        float: left;
        .heart-warp {
          padding: 4px, 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;
          width: 10%;
          float: right;
          .collect_blank {
            width: 22px;
            height: 22px;
            background: url($heart_blank) no-repeat;
            background-size: contain;
          }
          .collect_have {
            background: url($heart_have) no-repeat;
            background-size: contain;
          }
        }
        .des-warp {
          margin-top: 6px;
          width: 83%;
          .van-tag {
            float: left;
          }
          .des-text {
            margin-left: 4px;
            font-size: 16px;
            color: #3c4130;
          }
        }
      }

      .tag_area {
        width: 100%;
        text-align: left;
        display: flex;
        flex-wrap: wrap;
        margin-top: -10px;
        .tag_wrap {
          display: inline-block;
          min-width: 49px;
          height: 22px;
          line-height: 22px;
          font-size: 12px;
          text-align: center;
          border-radius: 11px;
          margin: 6px;
          padding: 0 10px;
          &:nth-child(5n + 1) {
            background-color: rgba(255, 148, 134, 0.1);
            color: #f56444;
          }
          &:nth-child(5n + 2) {
            background-color: #fff3ea;
            color: #ff8340;
          }
          &:nth-child(5n + 3) {
            background-color: rgba(73, 204, 154, 0.1);
            color: #49cc9a;
          }
          &:nth-child(5n + 4) {
            background-color: rgba(37, 166, 249, 0.1);
            color: #25a6f9;
          }
          &:nth-child(5n + 5) {
            background-color: rgba(157, 154, 255, 0.1);
            color: #887df7;
          }
        }
      }
      .author-warp {
        margin-top: 5px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #606f71;
        float: left;
        width: 100%;
        margin-bottom: 10px;
        .author-left {
          display: flex;
          align-items: center;
          .gray-circle {
            width: 16px;
            height: 16px;
            background: #c3cad6;
            border-radius: 999px;
          }
          .author-name {
            margin-left: 4px;
          }
        }
        .public-date {
        }
      }
    }

    .video_wrap_nopay {
      position: relative;
      width: 375px;
      height: 211px;
      background-position: center;
      background-size: 100%;
      .shape-vide {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        margin: auto;
        width: 60px;
        height: 60px;
      }
      .mask {
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }

  .mian-warp {
    // min-height: calc(100vh - 256px);
    // background-color: #f5f7fa;
    overflow-y: auto;
    padding-bottom: 50px;
    section {
      padding: 6px 20px 12px 20px;
      background-color: #fff;
      margin-top: 8px;
    }
    .more-videos {
      padding-bottom: 0;
    }

    .deatil-warp {
      margin-top: 16px;
      .deatil-title {
        font-size: 16px;
        color: #3c4130;
        line-height: 1.2;
        font-weight: 500;
      }
      .deatil-des {
        margin-top: 8px;
        font-size: 14px;
        color: #2e4344;
        line-height: 20px;
      }
    }

    .container_video {
      margin-top: 8px;
      .video_ul {
        display: flex;
        width: 100%;
        overflow-x: scroll;
        .video_li {
          margin-right: 20px;
          display: flex;
          flex-direction: column;
          align-items: center;
          &:last-child {
            margin-right: 0;
          }
          .the_video {
            width: 140px;
            height: 79px;
            position: relative;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              border-radius: 4px;
            }
            .img_bg {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 30px;
              height: 30px;
              background: url($video_bg) no-repeat;
              background-size: contain;
            }
            .price-tip {
              position: absolute;
              left: -67px;
              bottom: -22px;
              width: 134px;
              height: 44px;
              background-color: #ee3721;
              border-radius: 999px;
              .price-tip-text {
                position: absolute;
                top: 3px;
                right: 21px;
              }
            }
          }
          .the_video_1 {
            width: 140px;
            height: 79px;
            background-color: #f8f7fa;
            border-radius: 8px;
            position: relative;
            img {
              width: 135px;
              height: 76px;
            }
            .img_bg {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 30px;
              height: 30px;
              background: url($video_Blank) no-repeat;
              background-size: contain;
            }
          }
          .the_desc {
            margin-top: 8px;
            width: 140px;
            font-size: 14px;
            color: #2e4344;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
        }
      }
    }

    .purchase-notes {
      .purchase-notes-title {
        font-size: 16px;
        color: #3c4130;
        line-height: 1.2;
        font-weight: 500;
      }
      .purchase-notes-des {
        margin-top: 8px;
        font-size: 14px;
        color: #2e4344;
        line-height: 20px;
      }
    }
    .bottom {
      height: 100px;
      background-color: red;
    }
  }

  .footer-warp {
    position: fixed;
    padding: 0 20px 0 36px;
    bottom: 0px;
    width: 100%;
    height: 49px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // .heart-warp {
    //   padding: 4px, 0;
    //   display: flex;
    //   flex-direction: column;
    //   align-items: center;
    //   justify-content: space-between;
    //   .collect_blank {
    //     width: 22px;
    //     height: 22px;
    //     background: url($heart_blank) no-repeat;
    //     background-size: contain;
    //   }
    //   .collect_have {
    //     background: url($heart_have) no-repeat;
    //     background-size: contain;
    //   }
    // }

    .van-button {
      width: 300px;
      height: 40px;
      color: #ffffff !important;
      font-size: 16px;
      border: none;
      background: var(--btn-backgruond-color);
    }
  }

  .content_wrap {
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    min-height: 126px;
    // padding-top: 20px;
    overflow-y: auto;
    // border: 1px solid red;
    .wrap {
      width: 345px;
      .top_area {
        width: 100%;
        line-height: 24px;

        .desc_name {
          position: relative;
          font-size: 14px;
          color: #333;
          height: 17px;
          line-height: 17px;
          margin-left: 10px;
          z-index: -1;
          &::before {
            position: absolute;
            width: 6px;
            height: 6px;
            background-color: #f5a623;
            content: "";
            top: 50%;
            left: -10px;
            border-radius: 50%;
            transform: translateY(-50%);
          }
        }

        .top_item_1 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 11px;
        }
        .deatil_desc {
          height: auto;
          font-size: 14px;
          color: #666;
          margin-top: 11px;
        }
        .tag_area {
          height: 22px;
          line-height: 22px;
          margin-top: 12px;
          text-align: center;
          display: inline-block;
          .tag_wrap {
            display: inline-block;
            min-width: 49px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            border-radius: 11px;
            margin-right: 6px;
            &:last-child {
              margin-right: 0;
            }
            p {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 100%;
              height: 100%;
              span {
                display: inline-block;
                font-size: 12px;
                text-align: center;
                padding: 0 10px;
              }
            }
            &:nth-child(5n + 1) {
              background-color: rgba(255, 148, 134, 0.1);
              color: #f56444;
            }
            &:nth-child(5n + 2) {
              background-color: #fff3ea;
              color: #ff8340;
            }
            &:nth-child(5n + 3) {
              background-color: rgba(73, 204, 154, 0.1);
              color: #49cc9a;
            }
            &:nth-child(5n + 4) {
              background-color: rgba(37, 166, 249, 0.1);
              color: #25a6f9;
            }
            &:nth-child(5n + 5) {
              background-color: rgba(157, 154, 255, 0.1);
              color: #887df7;
            }
          }
        }
        .more_video {
          margin-top: 58px;
          p {
            height: 22px;
            line-height: 22px;
            font-size: 16px;
            color: #111;
          }
        }
      }
      .content_area {
        margin-top: 12px;
      }
    }

    padding-bottom: 20px;
  }
  .modal {
    .modal-body {
      margin-top: 6px;
      .score_area {
        .money {
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 50px;
            height: 50px;
            // margin-left: 4px;
          }
          span {
            margin-left: 4px;
          }
        }
        p {
          margin-top: 4px;
          font-size: 16px;
          color: #ff5151;
          font-weight: 500;
          margin-bottom: -25px;
        }
      }
    }
  }
}
::-webkit-scrollbar {
  width: 0px;
}

::-webkit-scrollbar-track {
  background-color: none;
}

::-webkit-scrollbar-thumb {
  background-color: none;
}

::-webkit-scrollbar-thumb:hover {
  background-color: none;
}

::-webkit-scrollbar-thumb:active {
  background-color: none;
}
</style>
